<div class="flex w-full" [ngClass]="LoginFromModal ? 'min-h-0' : 'h-screen'">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <!-- Left Section -->
  <div
    class="flex w-full flex-col bg-white"
    [ngClass]="LoginFromModal ? '' : 'md:w-1/2'"
  >
    <app-logo-header *ngIf="!LoginFromModal"></app-logo-header>

    <div
      class="flex flex-1 justify-center"
      [ngClass]="LoginFromModal ? 'py-2' : ''"
    >
      <div
        class="w-full px-6"
        [ngClass]="LoginFromModal ? 'max-w-[460px]' : 'max-w-[360px]'"
      >
        <h1
          class="text-gray-900 pb-3"
          [ngClass]="
            LoginFromModal
              ? 'text-2xl pt-2 text-center'
              : 'text-xl md:text-4xl pt-6 md:pt-12'
          "
        >
          {{ LoginFromModal ? "Sign in to continue" : "Log In" }}
        </h1>

        <p
          class="text-md text-gray-600 pb-8"
          [ngClass]="
            LoginFromModal ? 'text-center' : 'text-left md:text-center'
          "
        >
          {{
            LoginFromModal
              ? "Sign in without leaving your booking."
              : "Your Perfect Salon Experience Awaits!"
          }}
        </p>

        <form
          class="flex flex-col gap-5"
          (ngSubmit)="onSubmit()"
          #loginForm="ngForm"
        >
          <div class="floating-input">
            <input
              type="email"
              [(ngModel)]="email"
              name="email"
              required
              placeholder=" "
              autocomplete="email"
              class="w-full p-4 border-2 border-gray-200 rounded-3xl bg-white/50 backdrop-blur-sm focus:bg-white transition-all duration-300"
            />

            <label
              class="absolute left-4 top-[18px] text-gray-400 transition-all duration-300 pointer-events-none px-1 -mt-2 text-md"
            >
              Email
            </label>
          </div>

          <div class="floating-input">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              [(ngModel)]="password"
              name="password"
              required
              minlength="8"
              placeholder=" "
              autocomplete="current-password"
              class="w-full p-4 pr-12 border-2 border-gray-200 rounded-3xl bg-white/50 backdrop-blur-sm focus:bg-white transition-all duration-300"
            />

            <label
              class="origin-left absolute left-4 top-[18px] text-gray-400 transition-all duration-300 pointer-events-none px-1 -mt-2 text-md"
            >
              Password
            </label>

            <button
              type="button"
              (click)="toggleVisibility()"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label="Toggle password visibility"
            >
              <svg
                *ngIf="!passwordVisible"
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>

              <svg
                *ngIf="passwordVisible"
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.3-4.2M6.423 6.423A9.953 9.953 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.956 9.956 0 01-1.23 2.57M15 12a3 3 0 01-4.874 2.316M3 3l18 18"
                />
              </svg>
            </button>
          </div>

          <small class="text-gray-500"> Must be at least 8 characters. </small>

          <p *ngIf="errorMessage" class="text-red-500 text-sm">
            {{ errorMessage }}
          </p>

          <div class="flex flex-col gap-4 pt-4">
            <button
              type="submit"
              [ngClass]="
                isLoading
                  ? 'px-6 py-3 shadow rounded-3xl bg-gray-400 text-white cursor-not-allowed flex justify-center items-center'
                  : 'px-6 py-3 shadow rounded-3xl bg-gray-950 text-white'
              "
              [disabled]="isLoading || loginForm.invalid"
            >
              <svg
                *ngIf="isLoading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>

                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>

              {{ isLoading ? "Sending code..." : "Continue" }}
            </button>

            <ng-container *ngIf="!LoginFromModal">
              <glo-button
                icon="google"
                [fullWidth]="true"
                value="Log in with Google"
              />

              <glo-button
                icon="fb"
                [fullWidth]="true"
                value="Log in with Facebook"
              />
            </ng-container>
          </div>
        </form>

        <div class="pt-5 text-center">
          <p class="text-sm text-gray-600 mb-2">Don't have an account?</p>

          <a
            *ngIf="!LoginFromModal"
            routerLink="/sign-up"
            class="text-sm block pb-2"
          >
            Sign up as a
            <span class="font-semibold text-gray-900 text-sm"> Customer </span>
          </a>

          <button
            *ngIf="LoginFromModal"
            type="button"
            class="text-gray-900 font-semibold text-sm"
            (click)="requestRegistration()"
          >
            Create a customer account
          </button>

          <a
            *ngIf="!LoginFromModal"
            routerLink="/onboarding"
            class="block text-sm"
          >
            Sign up as an
            <span class="font-semibold text-gray-900 text-sm"> Owner </span>
          </a>
        </div>

        <button
          type="button"
          class="block w-full text-sm pt-4 pb-6 text-center text-gray-600 cursor-pointer hover:text-gray-900 transition-colors"
          (click)="openForgotPasswordModal()"
        >
          Forgot password?
        </button>
      </div>
    </div>
  </div>

  <!-- Right Section -->
  <div
    *ngIf="!LoginFromModal"
    class="hidden md:flex relative w-1/2 items-end bg-cover bg-center text-white p-10"
    [style.background-image]="'url(' + assetUrl + 'img/login-img.jpg)'"
  >
    <div
      class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-0"
    ></div>

    <div class="w-full max-w-[600px] relative z-10">
      <div class="flex w-full items-start pb-4">
        <img [src]="assetUrl + 'icons/Star.png'" alt="" />
      </div>

      <h2 class="text-6xl mb-4 text-white">
        Effortless Beauty, One Click Away
      </h2>

      <p class="mb-6 text-lg text-white">
        Create a free account and get full access to all features for 30-days.
        No credit card needed. Get started in 2 minutes.
      </p>

      <div class="flex items-center text-md">
        <div class="flex mr-2">
          <img [src]="assetUrl + 'img/avatars.png'" alt="" />
        </div>

        <div class="flex flex-col items-center gap-1">
          <span class="flex items-center text-white">
            <img
              [src]="assetUrl + 'icons/5stars.svg'"
              class="pr-2 h-5"
              alt=""
            />
            <span class="text-white pt-1">5.0</span>
          </span>

          <span class="text-white">from 200+ reviews</span>
        </div>
      </div>
    </div>
  </div>
</div>
